import React from 'react';
import type { ReviewDocument } from './types';
interface HoverPreviewProps {
  hoveredDoc: ReviewDocument | null;
  hoverPosition: {
    top: number;
    left: number;
  } | null;
  selectedDocId: string | null;
}
export function HoverPreview({
  hoveredDoc,
  hoverPosition,
  selectedDocId
}: HoverPreviewProps) {
  if (!hoveredDoc || !hoverPosition || hoveredDoc.id === selectedDocId) {
    return null;
  }
  return <div className="fixed z-[60] max-w-sm pointer-events-none animate-in fade-in duration-150" style={{
    top: hoverPosition.top,
    left: hoverPosition.left,
    transform: 'translate(-50%, -100%)'
  }} data-id="element-418">
      <div className="bg-[#0A1520] border border-navy-lighter rounded-lg shadow-2xl px-4 py-3 space-y-1.5" data-id="element-419">
        <div className="flex items-center gap-2" data-id="element-420">
          <span className="font-mono text-[10px] text-gray-500" data-id="element-421">
            {hoveredDoc.id}
          </span>
          <span className="text-gray-600" data-id="element-422">·</span>
          <span className="text-xs text-gray-400" data-id="element-423">{hoveredDoc.date}</span>
        </div>
        <div className="text-sm text-white font-medium leading-snug" data-id="element-424">
          {hoveredDoc.subject}
        </div>
        <p className="text-xs text-gray-400 leading-relaxed" data-id="element-425">
          {hoveredDoc.mediumSummary || hoveredDoc.summary}
        </p>
      </div>
    </div>;
}